/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartOutlets } from '@lm-nx-frontend/lm-inf-cart';
import { I18nModule } from '@lm-nx-frontend/lm-inf-core';
import { OutletPosition, provideOutlet } from '@lm-nx-frontend/lm-inf-ui';
import { ConfigureCartEntryModule } from '../configure-cart-entry/configure-cart-entry.module';
import { ConfiguratorCartEntryBundleInfoComponent } from './configurator-cart-entry-bundle-info.component';

@NgModule({
  imports: [CommonModule, I18nModule, ConfigureCartEntryModule],
  declarations: [ConfiguratorCartEntryBundleInfoComponent],

  providers: [
    provideOutlet({
      id: CartOutlets.ITEM_BUNDLE_DETAILS,
      position: OutletPosition.AFTER,
      component: ConfiguratorCartEntryBundleInfoComponent,
    }),
  ],
})
export class ConfiguratorCartEntryBundleInfoModule {}
